<div class="body" *ngIf="showContent">
    <div class="login-container text-center">
        <div class="logo mb-3"></div>
        <mrs-btn-primary buttonLabel="Sign In" buttonId="signInButton"
            (onClick)="signIn()">
          </mrs-btn-primary>
    </div>
</div>